export function scrollTo(element, to, duration) {
    // console.log('scrollto', 'woho');
    if (duration < 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 2;

    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        scrollTo(element, to, duration - 2);
    }, 10);
}

export function getDaysLong() {
    var days = [
        'Maandag',
        'Dinsdag',
        'Woensdag',
        'Donderdag',
        'Vrijdag',
        'Zaterdag',
        'Zondag'
    ];

    return days
}

export function getDayLong(day) {
    var days = {
        1: 'Maandag',
        2: 'Dinsdag',
        3: 'Woensdag',
        4: 'Donderdag',
        5: 'Vrijdag',
        6: 'Zaterdag',
        7: 'Zondag'
    };

    return days[day];
}


// WEBPACK FOOTER //
// ./src/utils.js